import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Form, Button, Select, Row, Col, Input, DatePicker, message, } from 'antd';
import { useI18n, LangSelect, useSession } from 'applib-frontend';
// eslint-disable-next-line import/no-unresolved
import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { useCookies } from 'react-cookie';
import dayjs from 'dayjs';
import 'dayjs/locale/cs';
import 'dayjs/locale/pl';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/sk';
import 'dayjs/locale/hr';
import 'dayjs/locale/sl';
import csCZ from 'antd/es/date-picker/locale/cs_CZ';
import plPL from 'antd/es/date-picker/locale/pl_PL';
import enUS from 'antd/es/date-picker/locale/en_US';
import deDE from 'antd/es/date-picker/locale/de_DE';
import skSK from 'antd/es/date-picker/locale/sk_SK';
import slSI from 'antd/es/date-picker/locale/sl_SI';
import hrHR from 'antd/es/date-picker/locale/hr_HR';
import './style.less';
const { Option } = Select;
const StreamForm = ({ onNewStream }) => {
    const { connection } = useSession();
    const [form] = Form.useForm();
    const [displayUrl, setDisplayUrl] = useState(false);
    const [cookies, setCookie] = useCookies(['lang']);
    const [channels, setChannels] = useState({});
    const [transcriptionLanguages, setTranscriptionLanguages] = useState([]);
    const { intl } = useI18n();
    let localeCalendar;
    const polishChannels = [
        channels.TVPInfo,
        channels.Jedynka,
        channels['Dwójka'],
        channels['Trójka'],
        channels['Czwórka'],
        channels.TVPInfo,
        channels.PR24,
        channels.rmfFM,
    ];
    const czechChannels = [
        channels['ČT 24'],
        channels['CNN Prima'],
        channels['ČRo Radiožurnál'],
    ];
    const slovakChannels = [
        channels.TA3,
    ];
    useEffect(() => {
        const fetchChannels = async () => {
            const channelsUrls = await connection.authFetch()
                .config({ endpointType: 'legacy' })
                .json()
                .url('api/stream2beey/SupportedUrls')
                .fetch();
            setChannels(channelsUrls);
        };
        const fetchTranscriptionProfiles = async () => {
            const profiles = await connection.authFetch()
                .json()
                .url(apiV2.currentUser.transcriptionProfiles.url())
                .fetch();
            const uniqueLangSet = [...new Set(profiles.map(((profile) => profile.lang)))];
            setTranscriptionLanguages(uniqueLangSet);
        };
        void fetchChannels();
        void fetchTranscriptionProfiles();
    }, []);
    switch (intl.locale) {
        case 'cs':
            localeCalendar = csCZ;
            csCZ.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        case 'pl':
            localeCalendar = plPL;
            plPL.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        case 'de':
            localeCalendar = deDE;
            deDE.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        case 'sk':
            localeCalendar = skSK;
            skSK.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        case 'hr':
            localeCalendar = hrHR;
            hrHR.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        case 'sl':
            localeCalendar = slSI;
            slSI.lang.now = intl.formatMessage({ id: 'currentTime' });
            break;
        default:
            localeCalendar = enUS;
            enUS.lang.now = intl.formatMessage({ id: 'currentTime' });
    }
    const saveLanguageToCookies = (language) => {
        setCookie('lang', language, {
            path: '/',
            expires: new Date(Date.now() + 1000000000),
        });
    };
    const handleSelectChannel = (value) => {
        setDisplayUrl(value === 'customUrl');
        if (polishChannels.includes(value)) {
            form.setFieldsValue({ language: 'pl-PL' });
            saveLanguageToCookies('pl-PL');
        }
        else if (czechChannels.includes(value)) {
            form.setFieldsValue({ language: 'cs-CZ' });
            saveLanguageToCookies('cs-CZ');
        }
        else if (slovakChannels.includes(value)) {
            form.setFieldsValue({ language: 'sk-SK' });
            saveLanguageToCookies('sk-SK');
        }
        else if (value === channels.N1INFO) {
            saveLanguageToCookies('sr-RS');
            form.setFieldsValue({ language: 'sr-RS' });
        }
    };
    const isURL = (url) => {
        const re = /^(http|https|rtmp):\/\/[^#%+,]{6,300}(#.*)?$/;
        return re.test(url);
    };
    const uploadTask = async () => {
        const channel = form.getFieldValue('channel');
        const date = form.getFieldValue('date');
        const selectedDate = dayjs(date);
        const currentDate = dayjs();
        const dateLocal = selectedDate.isBefore(currentDate, 'minute') ? currentDate.toISOString() : dayjs(date).toISOString();
        const url = form.getFieldValue('url');
        const name = form.getFieldValue('name');
        const hours = Number(form.getFieldValue('hours'));
        const minutes = Number(form.getFieldValue('minutes'));
        const length = `${hours}:${minutes}`;
        const [streamUrl, custom] = channel === 'customUrl' ? [encodeURIComponent(url), true] : [channel, false];
        if (hours === 0 && minutes === 0) {
            void message.error(`${intl.formatMessage({ id: 'durationAlert' })}`);
        }
        else {
            await connection.authFetch()
                .config({ endpointType: 'legacy' })
                .post()
                .url(`api/stream2beey/stream?startDate=${dateLocal}&length=${length}&streamUrl=${streamUrl}&name=${name}&language=${cookies.lang !== undefined ? cookies.lang : intl.locale}&custom=${custom}`)
                .send();
            onNewStream();
            form.resetFields(['channel', 'url', 'name', 'hours', 'minutes']);
            form.setFieldsValue({ date: dayjs() });
            setDisplayUrl(false);
        }
    };
    return (_jsxs("div", { className: "panel", children: [_jsx("h1", { children: intl.formatMessage({ id: 'dataNeeded' }) }), _jsxs(Form, { onFinish: () => uploadTask(), form: form, initialValues: {
                    date: dayjs(),
                    hours: 1,
                    minutes: 0,
                    language: cookies.lang !== undefined ? cookies.lang : intl.locale,
                }, children: [_jsxs(Row, { children: [_jsx(Col, { sm: 6, xs: 7, children: _jsxs("p", { children: [_jsx("span", { className: "asterisk", children: "*" }), ' ', "Stream:"] }) }), _jsx(Col, { md: 6, sm: 16, xs: 16, children: _jsx(Form.Item, { name: "channel", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                    ], children: _jsxs(Select, { onChange: handleSelectChannel, placeholder: intl.formatMessage({ id: 'selectChannel' }), children: [_jsx(Option, { value: "customUrl", children: intl.formatMessage({ id: 'customUrl' }) }), Object.entries(channels).map(([key, value]) => (_jsx(Option, { value: value, children: key.charAt(0).toUpperCase() + key.slice(1) }, key)))] }) }) }), _jsx(Col, { md: { span: 3, offset: 1 }, sm: 6, xs: 7, className: "lang-input", children: _jsxs("p", { children: [' ', intl.formatMessage({ id: 'language' }), ":"] }) }), _jsx(Col, { md: 6, sm: 16, xs: 16, children: _jsx(Form.Item, { name: "language", children: _jsx(LangSelect, { langs: transcriptionLanguages, value: "", onChange: (language) => saveLanguageToCookies(language) }) }) })] }), displayUrl ? (_jsxs(Row, { children: [_jsx(Col, { sm: 6, xs: 7, children: _jsxs("p", { children: [_jsx("span", { className: "asterisk", children: "*" }), ' ', intl.formatMessage({ id: 'customUrl' }), ":"] }) }), _jsx(Col, { md: 17, sm: 16, xs: 16, className: "custom-input", children: _jsx(Form.Item, { name: "url", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                        {
                                            validator: async (_, value) => {
                                                if (value === undefined || value === null) {
                                                    return Promise.reject();
                                                }
                                                if (isURL(value)) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(intl.formatMessage({ id: 'invalidURL' }));
                                            },
                                        },
                                    ], children: _jsx(Input, { placeholder: "https://" }) }) })] })) : null, _jsxs(Row, { children: [_jsx(Col, { sm: 6, xs: 7, style: { paddingRight: '5px' }, children: _jsxs("p", { children: [_jsx("span", { className: "asterisk", children: "*" }), ' ', intl.formatMessage({ id: 'startTime' }), ":"] }) }), _jsx(Col, { md: 6, sm: 16, xs: 16, children: _jsx(Form.Item, { name: "date", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                        {
                                            validator: async (_, value) => {
                                                if (value === null) {
                                                    return Promise.reject();
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ], children: _jsx(DatePicker, { showTime: { format: 'HH:mm' }, format: ['DD/MM/YYYY  HH:mm'], placeholder: intl.formatMessage({ id: 'start' }), showNow: true, locale: localeCalendar }) }) }), _jsx(Col, { md: { span: 3, offset: 1 }, sm: 6, xs: 7, children: _jsxs("p", { children: [_jsx("span", { className: "asterisk", children: "*" }), ' ', intl.formatMessage({ id: 'length' }), ":"] }) }), _jsx(Col, { md: 2, sm: 3, xs: 4, children: _jsx(Form.Item, { name: "hours", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                    ], children: _jsx(Input, { type: "number", min: "0", max: "23" }) }) }), _jsx(Col, { md: 2, sm: 3, xs: 4, style: { paddingLeft: '5px' }, children: _jsx("p", { children: intl.formatMessage({ id: 'hours' }) }) }), _jsx(Col, { md: 2, sm: 3, xs: 4, children: _jsx(Form.Item, { name: "minutes", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                    ], children: _jsx(Input, { type: "number", max: "59", min: "0" }) }) }), _jsx(Col, { md: 2, sm: 3, xs: 4, style: { paddingLeft: '5px' }, children: _jsx("p", { children: intl.formatMessage({ id: 'minutes' }) }) })] }), _jsxs(Row, { children: [_jsx(Col, { sm: 6, xs: 7, children: _jsxs("p", { children: [_jsx("span", { className: "asterisk", children: "*" }), ' ', intl.formatMessage({ id: 'taskName' }), ":"] }) }), _jsx(Col, { md: 17, sm: 16, xs: 16, className: "custom-input", children: _jsx(Form.Item, { name: "name", rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'requiredField' }),
                                        },
                                    ], children: _jsx(Input, { type: "text", placeholder: intl.formatMessage({ id: 'enterTaskName' }) }) }) })] }), _jsx(Col, { xs: 24, className: "btn-form", children: _jsx(Button, { htmlType: "submit", children: intl.formatMessage({ id: 'run' }) }) })] })] }));
};
export default StreamForm;
